<template>
    <div class="btn-group">
        <button v-if="canPlay" class="btn btn-secondary btn-sm" @click="play">
            <i class="fas fa-play"></i>
        </button>
        <button v-if="canStop" class="btn btn-secondary btn-sm" @click="stop">
            <i class="fas fa-stop"></i>
        </button>
        <button v-if="canEdit" class="btn btn-secondary btn-sm" @click="edit">
            <i class="fas fa-edit"></i>
        </button>
        <button v-if="canDelete" class="btn btn-danger btn-sm" @click="confirmDeleting">
            <i class="fas fa-trash-alt"></i>
        </button>
    </div>
</template>

<script>

  export default {
    props: {
      row: Object,
      playingId: Number,
    },

    computed: {
      /**
       * @return {object}
       */
      model() {
        return this.row.model;
      },

      /**
       * @return {boolean}
       */
      canEdit() {
        return this.row.canEdit;
      },

      /**
       * @return {boolean}
       */
      canDelete() {
        return this.row.canDelete;
      },

      /**
       * @return {boolean}
       */
      canPlay() {
        return !this.canStop;
      },

      /**
       * @return {boolean}
       */
      canStop() {
        return this.model.id === this.playingId;
      },

      /**
       * @return {string}
       */
      editUrl() {
        return this.row.editUrl;
      },

      /**
       * @return {string}
       */
      deleteUrl() {
        return this.row.deleteUrl;
      },
    },

    methods: {
      /**
       * @emits play
       */
      play() {
        this.$emit('play', {
          id: this.model.id,
          url: this.model.url
        });
      },

      /**
       * @emits play
       */
      stop() {
        this.$emit('stop');
      },

      /**
       * @emits edit
       */
      edit() {
        this.$emit('edit', {row: this.row, url: this.editUrl});
      },

      /**
       * @emits delete
       */
      confirmDeleting() {
        this.$confirm('Are you sure you want to delete this item?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        })
          .then(() => this.$emit('delete', {row: this.row, url: this.deleteUrl}))
          .catch(() => {
          });
      },
    },
  }
</script>

